import { Button, Text } from '#atoms';
import { useState } from 'react';
import {
  ButtonBox,
  Container,
  GenderCheckBox,
  GenderSelectBox,
  Select
} from './styles';
import { useFormContext } from 'react-hook-form';

interface ModalProps {
  onClose: () => void;
}

export const PortfolioModal = ({ onClose }: ModalProps) => {
  const methods = useFormContext();
  const [age, setAge] = useState<number | null>(null);
  const [gender, setGender] = useState<string | null>(null);
  const handleAgeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setAge(Number(e.target.value));
  };
  return (
    <Container>
      <Text textStyle="t3" style={{ textAlign: 'center' }}>
        회원 정보를 <br /> 입력해주세요
      </Text>
      <Select value={age ?? ''} onChange={handleAgeChange}>
        <option value="" disabled>
          회원 연령 선택
        </option>
        {Array.from({ length: 100 }, (_, i) => i + 1).map(age => (
          <option key={age} value={age}>
            {age}세
          </option>
        ))}
        {/* <BoxIcon type="down-arrow-gray" width={15} onlyIcon /> */}
      </Select>
      <GenderSelectBox>
        <GenderCheckBox>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            onClick={() => {
              if (gender !== 'male') {
                setGender('male');
              } else {
                setGender(null);
              }
            }}
          >
            <rect
              rx={18}
              ry={18}
              fill={gender === 'male' ? '#7750E9' : '#383441'}
              width={18}
              height={18}
            ></rect>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.5 7.5L3 9L7.5 13.5L15 6L13.5 4.5L7.5 10.5L4.5 7.5Z"
              fill={gender === 'male' ? 'white' : '#5C576B'}
            />
          </svg>
          남성
        </GenderCheckBox>
        <GenderCheckBox>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            onClick={() => {
              if (gender !== 'female') {
                setGender('female');
              } else {
                setGender(null);
              }
            }}
          >
            <rect
              rx={18}
              ry={18}
              fill={gender === 'female' ? '#7750E9' : '#383441'}
              width={18}
              height={18}
            ></rect>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.5 7.5L3 9L7.5 13.5L15 6L13.5 4.5L7.5 10.5L4.5 7.5Z"
              fill={gender === 'female' ? 'white' : '#5C576B'}
            />
          </svg>
          여성
        </GenderCheckBox>
      </GenderSelectBox>
      <ButtonBox>
        <Button
          background="anti"
          style={{ color: '#C9C7D1' }}
          onClick={onClose}
        >
          닫기
        </Button>
        <Button
          onClick={() => {
            methods.setValue('age', age);
            methods.setValue('sex', gender);
            onClose();
          }}
        >
          확인
        </Button>
      </ButtonBox>
    </Container>
  );
};
